//import '@ungap/custom-elements'; // Déclaré dans le  main.js pour d'autres custom elements

// Declare all custom elements
import AutoHideOverflow from "./components/AutoHideOverflow";
customElements.define('auto-hide-overflow', AutoHideOverflow, {extends: 'div'});

import AutoSplide from "./components/AutoSplide";
customElements.define('auto-splide', AutoSplide, {extends: 'div'});

import CollapseLongContent from "./components/CollapseLongContent";
customElements.define('collapse-long-content', CollapseLongContent);

import ProductGallery from "./components/ProductGallery";
customElements.define('product-gallery', ProductGallery);

import RecipeGallery from "./components/RecipeGallery";
customElements.define('recipe-gallery', RecipeGallery);

import RecipeHead from "./components/RecipeHead";
customElements.define('recipe-head', RecipeHead);

import InputPassword from "./components/InputPassword";
customElements.define('input-password', InputPassword);

/**
 * Le composant QuantitySelector est surchargé dans l'app et donc plus utile ici, si modif, a reporter dans /ressources/js/components/QuantitySelector.js
 */
//import QuantitySelector from "./components/QuantitySelector";
//customElements.define('quantity-selector', QuantitySelector);

// Le composant SearchProducts est désactivé pour l'implémentation dans le projet,
// car il est géré par le module hegyd/products
// import SearchProducts from "./components/SearchProducts";
// customElements.define('search-products', SearchProducts, {extends: 'div'});

//import CustomSiteHeader from "./components/SiteHeader";
//customElements.define('site-header', SiteHeader);

// On charge uniquement les modules bootstrap utiles

// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
// import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/offcanvas';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';
// import 'bootstrap/js/dist/tooltip';

// Pour la compatibilité pleine et entière avec les modules Hegyd (notamment Modalator.js)
// on est malheureusement obligé de charger bootstrap de cette manière...
window.bootstrap = require('bootstrap');
